module.exports = __webpack_public_path__ + "img/Image3.6eedf8f8.png";